import $ from 'jquery';

const schema = {
	blocks: {
		text: {
			copy: block => {
				let str = block.content.html;
				try {
					str = $(str).text();
				} catch (err) {
					// catch error here
				}
				str += '\n';
				return str;
			}
		},
		folder: {
			copy: block => {
				let str = block.content.title || '';
				str += '\n';
				return str;
			}
		}
	}
};

export default schema;
